.checkboxWrapper {
  display: grid;
  justify-content: flex-start;
}

.checkboxWrapperChecked {
  border-radius: 8px;
}

.checkboxWrapperDisabled {
  opacity: 0.5;
}

.checkboxRow {
  display: flex;
  column-gap: 15px;
}

.checkboxGridCell {
  display: flex;
  justify-content: flex-start;
}

.customerInfoRow {
  padding: 15px;
}

.labelGridCell {
  display: flex;
  align-items: center;
  position: relative;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.2px;
  color: #16182b;
}

.labelGridCellCompact {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.checkboxLabel {
  cursor: pointer;
}

.checkboxWrapperDisabled .checkboxLabel,
.checkboxWrapperDisabled input {
  cursor: not-allowed;
}

@mixin checkboxMain {
  -webkit-appearance: none;
  background: #ffffff;
  border: 1px solid #a8aab8;
  box-sizing: border-box;
  border-radius: 6px;
  width: 24px;
  height: 24px;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  &:focus-visible {
    outline: 2px solid #16182b;
    outline-offset: 2px;
  }
}

@mixin checkboxChecked {
  background: #4d5ef2;
  border: 1px solid #4d5ef2;
}

@mixin checboxCheckedAfter {
  content: url('data:image/svg+xml;utf8,<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.91006 7.49585L1.7071 5.29291C1.31658 4.90239 0.683416 4.90239 0.292893 5.29291C-0.0976309 5.68343 -0.0976309 6.3166 0.292893 6.70712L3.29288 9.70709C3.7168 10.131 4.4159 10.0892 4.7863 9.61781L11.7863 1.61786C12.1275 1.18359 12.0521 0.554936 11.6178 0.213723C11.1835 -0.127489 10.5549 -0.0520504 10.2136 0.38222L3.91006 7.49585Z" fill="white"/></svg>');
  margin: 1px 0 0 0;
}

@mixin checkboxIndeterminateAfter {
  content: url('data:image/svg+xml;utf8,<svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="8" height="2" rx="1" fill="white"/></svg>');
  margin: 0 0 9px 0;
}

.checkbox[type="checkbox"] {
  @include checkboxMain();
}

.checkbox[type="checkbox"]::after {
  position: relative;
}

.checkbox[type="checkbox"]:checked {
  @include checkboxChecked();
}

.checkbox[type="checkbox"]:checked::after {
  @include checboxCheckedAfter();
}

.checkbox[type="checkbox"]:indeterminate {
  @include checkboxChecked();
}

.checkbox[type="checkbox"]:indeterminate::after {
  @include checkboxIndeterminateAfter();
}

.checkboxError[type="checkbox"] {
  @include checkboxMain();
}

.checkboxError[type="checkbox"]:not(:checked) {
  border: 2px solid #ef2039;
}

.checkboxError[type="checkbox"]:checked {
  @include checkboxChecked();
}

.checkboxError[type="checkbox"]:checked::after {
  @include checkboxIndeterminateAfter();
}

.checkboxError[type="checkbox"]:indeterminate {
  @include checkboxChecked();
}

.checkboxError[type="checkbox"]:indeterminate::after {
  @include checkboxIndeterminateAfter();
}
